/*
******************************************************************
* pr_script.js
******************************************************************
*/
var UaInfo = (function () {
    var that = {};
    var userAgent = window.navigator.userAgent.toLowerCase();
    var appVersion = window.navigator.appVersion.toLowerCase();
    that.browser;
    that.os;
    that.ieVr;
    that.interface;

    if (userAgent.indexOf('iphone') > 0 || userAgent.indexOf('ipod') > 0) {
        that.os = 'iPhone';
        that.interface = 'touch';
    } else if (userAgent.indexOf('ipad') > 0) {
        that.os = 'iPad';
        that.interface = 'touch';
    } else if (userAgent.indexOf('android') > 0) {
        if (userAgent.indexOf('mobile') > 0) {
            that.os = 'Android';
        } else {
            that.os = 'AndroidTab';
        }
        that.interface = 'touch';
    } else if (userAgent.match(/mac|ppc/)) {
        that.os = 'mac';
        that.interface = 'mouse';
    } else {
        that.os = 'other';
        that.interface = 'mouse';
    }

    if (userAgent.indexOf('msie') != -1) {
        that.browser = 'ie';
        if (appVersion.indexOf('msie 8.') != -1) {
            that.ieVr = 8;
        } else if (appVersion.indexOf('msie 9.') != -1) {
            that.ieVr = 9;
        } else if (appVersion.indexOf('msie 10.') != -1) {
            that.ieVr = 10;
        }
    } else if (appVersion.indexOf("trident/7.0") > -1) {
        that.browser = 'ie';
        that.ieVr = 11;
    } else if (userAgent.indexOf('chrome') != -1) {
        that.browser = 'chrome';
    } else if (userAgent.indexOf('safari') != -1) {
        that.browser = 'safari';
    } else if (userAgent.indexOf('firefox') != -1) {
        that.browser = 'firefox';
    };
    return that;
})();
(function ($) {
    function uaInfoJudg() {
        var that = {};
        var userAgent = window.navigator.userAgent.toLowerCase();
        var appVersion = window.navigator.appVersion.toLowerCase();
        if (userAgent.indexOf('ipad') > 0) {
            $('html').addClass('js_pr_os-ipad');
        }
        else if (userAgent.match(/mac|ppc/)) {
            $('html').addClass('js_pr_os-mac');
        }
        else if (userAgent.indexOf('android') > 0) {
            if (userAgent.indexOf('mobile') > 0) {
                $('html').addClass('js_pr_os-android');
            }
            else {
                $('html').addClass('js_pr_os-androidtab');
            }
        }
        /*windows*/
        else {
            $('html').addClass(' js_pr_os-win');
        }
        /*borowser judge*/
        if (userAgent.indexOf('firefox') != -1) {
            $('html').addClass(' js_pr_browser-firefox');
            use_browser = "firefox";
        }
        else if (userAgent.indexOf('msie') != -1) {
            $('html').addClass(' js_pr_browser-ie');
        }
        else {
            ;
        }

        if (userAgent.indexOf('msie') != -1 ||
            userAgent.indexOf('trident') != -1) {
            $('html').addClass(' js_pr_browser-ie');
        }
        else if (userAgent.indexOf('edge') != -1) {
            ;
        }
        else if (userAgent.indexOf('chrome') != -1) {
            ;
        }
        else if (userAgent.indexOf('safari') != -1) {
            $('html').addClass(' js_pr_browser-safari');
        }
        else if (userAgent.indexOf('firefox') != -1) {
            $('html').addClass(' js_pr_browser-firefox');
            use_browser = "firefox";
        }
        else {
            ;
        }
    };
    var all_scroll_points = 0;
    TSUCHIYA_COMMON = {

        table_head_fixed: function () {
            if ($('.js_pr_table-head-fixed').length) {
                $('.js_pr_table-head-fixed').each(function () {
                    var target_ele = $(this).attr('data-table');
                    var target_head = $(this).attr('data-head');
                    var target_body = $(this).attr('data-body');
                    var clone = $(target_head).prop('outerHTML');
                    $(target_head).addClass('js_pr_table-head-origin');
                    $(target_head).before(clone);
                    $(this).find(target_ele).css('position', 'relative');
                    $(target_head).not('.js_pr_table-head-origin').addClass('js_pr_table-head-clone');
                    $(this).find('.js_pr_table-head-clone').css({ 'opacity': '0', 'position': 'fixed', 'top': '0', 'left': '0', 'z-index': '10' });
                });

                function head_cell_sync() {
                    if ($('.js_pr_table-head-clone').length) {
                        $('.js_pr_table-head-origin').find('th').each(function (i) {
                            var ele_w = $(this).outerWidth();
                            $('.js_pr_table-head-clone').find('th').eq(i).css('width', ele_w + 'px');
                        });
                        var head_w = $('.js_pr_table-head-fixed').find('table').outerWidth();
                        $('.js_pr_table-head-clone').css('width', head_w + 'px');
                    }
                }

                function fixed_action() {
                    var header_h = $('.site-header').outerHeight();
                    var table_h = $('.js_pr_table-head-fixed').find('table').height();
                    var table_head_h = $('.js_pr_table-head-clone').height();
                    var ele_off_t = $('.js_pr_table-head-fixed').offset().top;
                    var ele_off_l = $('.js_pr_table-head-fixed').offset().left;
                    var scroll_v = $(window).scrollTop();
                    var scroll_l_v = $(window).scrollLeft();
                    var table_v = $('.tr_table-container').scrollLeft();

                    if (scroll_v + header_h >= ele_off_t) {//テーブルヘッダーを画面上へ固定する為の判定
                        if (scroll_v >= (table_h + ele_off_t) - (header_h + table_head_h)) {//テーブルの一番下までスクロールした場合の判定
                            $('.js_pr_table-head-fixed').addClass('js_pr_table-head-fixed-off');
                            $('.js_pr_table-head-clone').css({ 'opacity': '1', 'position': 'absolute', 'top': 'auto', 'left': 0, 'bottom': 0 });
                        } else {
                            $('.js_pr_table-head-fixed').removeClass('js_pr_table-head-fixed-off');
                            if (window.matchMedia('(min-width: 768px)').matches) {
                                $('.js_pr_table-head-origin').css({ 'opacity': '0' });
                                $('.js_pr_table-head-clone').css({ 'opacity': '1', 'position': 'fixed', 'top': header_h + 'px', 'left': ele_off_l - scroll_l_v + 'px', 'bottom': 'auto' });
                            } else {
                                $('.js_pr_table-head-origin').css({ 'opacity': '0' });
                                $('.js_pr_table-head-clone').css({ 'opacity': '1', 'position': 'fixed', 'top': header_h + 'px', 'left': -table_v + 'px', 'bottom': 'auto' });
                            }
                        }
                    } else {
                        $('.js_pr_table-head-origin').css({ 'opacity': '1' });
                        $('.js_pr_table-head-clone').css({ 'opacity': '0' });
                    }
                }

                $('.tr_table-container').on('scroll', function () {
                    if (!$('.js_pr_table-head-fixed').hasClass('js_pr_table-head-fixed-off')) {
                        var table_v = $('.tr_table-container').scrollLeft();
                        $('.js_pr_table-head-clone').css('left', -table_v + 'px');
                    }
                });

                head_cell_sync();
                fixed_action();

                $(window).on('resize', function () {
                    head_cell_sync();
                    fixed_action();
                });
                $(window).on('scroll', function () {
                    fixed_action();
                });
            }
        },
        head_menu_dropdown: function () {
            var w_judge = window.matchMedia('screen and (min-width: 920px)');
            if (w_judge) {
                //PCmenu active
                function head_menu_item_adjuster(target_p) {
                    var max_width = 0;
                    target_p.each(function (index, element) {
                        $(this).children().each(function (index, element) {
                            var _this_width = $(this).width();
                            if (_this_width > max_width)
                                max_width = Math.round(_this_width);
                            // console.log('max_width:' + max_width + '_this_width:' + _this_width);
                        });
                        //widthに設定
                        $(this).children().css('width', max_width);
                        //初期化
                        max_width = 0;
                        // console.log('loop:' + index);
                    });
                }
                $('html').addClass('js-pr-html-settings');
                // head_menu_item_adjuster($('.pr_tr-site-nav-list .site-nav__dropdown'));
                // $('.js-pr-none-drop').on('mouseenter', function () {
                //     $('.site-nav--has-dropdown').addClass('js-pr-none-drop').removeClass('js-pr-drop-active');
                //     $(this).removeClass('js-pr-none-drop');
                //     $(this).addClass('js-pr-drop-active');
                //     $(this).addClass('js-pr-link-active');
                // });
                //PCmenu none active
                // $('main,footer').on('mouseleave', function () {
                //     $('.site-nav--has-dropdown').addClass('js-pr-none-drop').removeClass('js-pr-drop-active').removeClass('js-pr-link-active');
                // });

                $('.js-pr-none-drop').on({
                    'mouseenter': function () {
                        $('.site-nav--has-dropdown').addClass('js-pr-none-drop').removeClass('js-pr-drop-active');
                        $(this).removeClass('js-pr-none-drop');
                        $(this).addClass('js-pr-drop-active');
                        $(this).addClass('js-pr-link-active');
                    },
                    'mouseleave': function () {
                        $('.site-nav--has-dropdown').addClass('js-pr-none-drop').removeClass('js-pr-drop-active').removeClass('js-pr-link-active');
                    }
                });
            }
            else {
                ;
            }
        },
        head_height_measure: function () {
            var w_judge = window.matchMedia('screen and (max-width: 919px)').matches;
            if (w_judge) {
                var h_all_height = $('#shopify-section-header').height();
                $('header').append('<style>' + '#shopify-section-header .drawer{top: ' + h_all_height + 'px}</style>');
            }
            else {
                ;
            }
        },
        head_scroll: function () {
            var w_judge = window.matchMedia('screen and (max-width: 919px)').matches;
            var h_all_height = $('#StickyHeaderWrap').height();
            //if ($('.announcement').length > 0) {
            //    h_all_height = $('#StickyHeaderWrap').height() + $('.announcement').height();
            //}
            var h_only_height = $('#StickyHeaderWrap').height();
            var h_all_height_new_menu_add = $('.announcement').height() + $('#StickyHeaderWrap').height() + $('.pr_tr-sp-header-original-box').height();

            var scroll_points = $(window).scrollTop();

            if (w_judge) {

                if (all_scroll_points > h_all_height) {
                    $('#shopify-section-header .header-wrapper').addClass('js-pr-header-fixed');
                }
                else {
                    $('#shopify-section-header .header-wrapper').removeClass('js-pr-header-fixed');
                }

                //スクロールの向きを判定
                if (scroll_points > h_all_height) {
                    if (all_scroll_points < scroll_points) {
                        $('.pr_tr-sp-header-original-box').addClass('js-pr-scroll-up');
                    }
                    else {
                        $('.pr_tr-sp-header-original-box').removeClass('js-pr-scroll-up');
                    }
                }
                else {
                    $('.pr_tr-sp-header-original-box').removeClass('js-pr-scroll-up');
                }

                all_scroll_points = scroll_points;

                //ヘッダーが固定になる
                if ($('header').hasClass('site-header--stuck')) {
                    $('.drawer__inner').addClass('js-pr-menu-fixed');
                    // ▼menu内の余分な高さを削除_230804
                    // $('.drawer').css('padding-top', h_all_height);
                }
                //固定化解除
                else {
                    $('.drawer__inner').removeClass('js-pr-menu-fixed');
                    // ▼menu内の余分な高さを削除_230804
                    // $('.drawer').css('padding-top', h_all_height);
                }

            // ハンバーガーメニューのスクロール位置を常にTOPに
            var scrollPosition = document.getElementById("NavDrawer");
            scrollPosition.scrollTop = 0;

            }
            else {
                ;
            }
        },
        head_scroll_road: function () {
            var w_judge = window.matchMedia('screen and (max-width: 919px)').matches;
            var h_all_height = $('#StickyHeaderWrap').height();
            if ($('.announcement').length > 0) {
                h_all_height = $('#StickyHeaderWrap').height() + $('.announcement').height();
            }
            var h_only_height = $('#StickyHeaderWrap').height();
            $('.js-pr-drawer-open-trig').addClass('js-pr-drawer-btn-locked');
            $('.js-pr-drawer-open-cart').addClass('js-pr-drawer-btn-locked');
            setTimeout(function () {
                if (w_judge) {
                    //ヘッダーが固定になる
                    if ($('header').hasClass('site-header--opening')) {
                        $('.drawer__inner').addClass('js-pr-menu-fixed');
                        // ▼menu内の余分な高さを削除_230804
                        // $('.drawer').css('padding-top', h_all_height);
                    }
                    //固定化解除
                    else {
                        $('.drawer__inner').removeClass('js-pr-menu-fixed');
                        // ▼menu内の余分な高さを削除_230804
                        // $('.drawer').css('padding-top', h_all_height);
                    }
                    $('.js-pr-drawer-open-trig').removeClass('js-pr-drawer-btn-locked');
                    $('.js-pr-drawer-open-cart').removeClass('js-pr-drawer-btn-locked');
                }
                else {
                    ;
                }
            }, 100);
        },
        head_menu_drawer: function () {
            var w_judge = window.matchMedia('screen and (max-width: 919px)').matches;
            var area_judge = '';
            if (w_judge) {

                //none scroll

                var target_box = document.querySelector('.drawer.drawer--left .drawer__inner');
                var target_box002 = document.querySelector('.drawer.drawer--right .drawer__inner');
                var scroll_pos = 0;

                $('.js-pr-drawer-open-trig').on('click', function () {
                    scroll_pos = $(window).scrollTop();

                    all_scroll_points = scroll_pos;

                    $('body').css('position', 'fixed');
                    $('body').css('top', (-1) * scroll_pos);

                    $('#shopify-section-header').addClass('js-pr-drawer-open-header');

                    //$('#shopify-section-header .header-wrapper').css('top', scroll_pos);

                    $(this).parents('.pr_tr-site-nav-btn-box').addClass('js-pr-trig-active');
                    $('.drawer').removeClass('drawer--is-open');
                    area_judge = $(this).attr('aria-controls');
                    if (area_judge == 'NavDrawer') {
                        $('#NavDrawer.drawer').addClass('drawer--is-open');
                        // $('.js-pr-drawer-open-cart').addClass('js-pr-drawer-btn-locked');
                        // 230214SPハンバーガー展開時にカートアイコンを押せるようにする
                    }
                    else if (area_judge == 'CartDrawer') {
                        $('.js-pr-drawer-open-trig').addClass('js-pr-drawer-btn-locked');
                    }
                });
                //cart only
                $('.js-pr-drawer-open-cart').on('click', function () {
                    var scroll_pos = $(window).scrollTop();
                    $('.js-pr-drawer-open-trig').addClass('js-pr-drawer-btn-locked');
                });
                $('.js-pr-cart-close').on('click', function () {
                    $('.js-pr-drawer-open-trig').removeClass('js-pr-drawer-btn-locked');
                });

                $('.js-pr-drower-close').on('click', function () {

                    $('body').css('position', 'static');
                    $('body').css('top', 'auto');

                    $(window).scrollTop(scroll_pos);

                    //$('#shopify-section-header .header-wrapper').css('top', 'auto');

                    $('#shopify-section-header').removeClass('js-pr-drawer-open-header');
                    $(this).parents('.pr_tr-site-nav-btn-box').removeClass('js-pr-trig-active');
                    $('.js-pr-drawer-open-cart').removeClass('js-pr-drawer-btn-locked');
                    $('.drawer').removeClass('drawer--is-open');
                });
            }
            else {
                ;
            }
        },
        main_padding_calc: function () {
            var w_judge = window.matchMedia('screen and (max-width: 919px)').matches;
            var main_padding = $('#StickyHeaderWrap').height();
            /*SPモード*/
            if (w_judge) {
                /*announce men bar があるとき*/
                if ($('.announcement').length > 0) {
                    if ($('.announcement').hasClass('announcement--closed')) {
                      main_padding = $('#StickyHeaderWrap').height() + $('.pr_tr-sp-header-original-box').height();
                    } else {
                    main_padding = $('.announcement').height() + $('#StickyHeaderWrap').height() + $('.pr_tr-sp-header-original-box').height();
                    }
                    if ($('.pr_tr-sp-header-original-box').length == 0) {
                        main_padding = $('.announcement').height() + $('#StickyHeaderWrap').height();
                    }
                }
                else {
                    main_padding = $('#StickyHeaderWrap').height() + $('.pr_tr-sp-header-original-box').height();
                }
            }
            /*PCモード*/
            else {
                if ($('.announcement').length > 0) {
                  if ($('.announcement').hasClass('announcement--closed')) {
                  } else {
                    main_padding = $('.announcement').height() + $('#StickyHeaderWrap').height();
                }
                }
                else {
                    ;
                }
            }
            /*SPモード*/
            if (w_judge) {
                if($('body').hasClass('template-index')){}else{
                    if ($('.announcement').length > 0) {
            //            main_padding = $('.announcement').height() + $('#StickyHeaderWrap').height() + $('.pr_tr-sp-header-original-box').height();
                    }

                }
                    }
                    // ▼プライマリナビの高さを削除_230804
                    // $('main').css('padding-top', main_padding);
                    $('.pr_tr-main-content-sp-header-back').css('height', main_padding);
            if (w_judge) {
              if ($('.announcement').hasClass('announcement--closed')) {
                    // ▼menu内の余分な高さを削除_230804
                    // $('.drawer__inner').css('padding-top', "");
              } else {
                var drawer_padding = parseInt($('.announcement').height()) + 44;
                    // ▼menu内の余分な高さを削除_230804
                    // $('.drawer__inner').css('padding-top', drawer_padding + "px");
                }
            }
          
        }
    }
    $(window).on('load', function () {
        uaInfoJudg();

        TSUCHIYA_COMMON.table_head_fixed();
        TSUCHIYA_COMMON.head_menu_dropdown();
        TSUCHIYA_COMMON.head_menu_drawer();
        TSUCHIYA_COMMON.head_scroll_road();
    });
    $(window).on('scroll', function () {
        TSUCHIYA_COMMON.head_scroll();
    });
    $(window).on('load resize', function () {
        TSUCHIYA_COMMON.main_padding_calc();

    });
    const target = document.getElementById('announcement');
    const observer = new MutationObserver(records => {
      window.setTimeout(function() {
        TSUCHIYA_COMMON.main_padding_calc();
      }, 300);
    });
    observer.observe(target, {
      attributes: true
    });
})(jQuery);
